
import React from 'react';
import SEO from '../components/SEO';

const CookiePolicy: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <SEO 
        title="Cookie Policy" 
        description="Information about how AviaGov uses cookies to enhance platform performance." 
      />
      <section className="py-24 px-4 max-w-4xl mx-auto">
        <h1 className="text-4xl lg:text-6xl font-bold font-heading mb-8 text-white">Cookie Policy</h1>
        <p className="text-slate-400 mb-12">Last Updated: October 24, 2024</p>

        <div className="prose prose-invert prose-slate max-w-none space-y-8 text-slate-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. What are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device that help us provide a seamless experience on the AviaGov platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Cookies</h2>
            <p>We use cookies for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-4 mt-4">
              <li><strong>Essential Cookies:</strong> Required for secure login, RBAC sessions, and AIRAC workflow state management. These cannot be disabled.</li>
              <li><strong>Preference Cookies:</strong> Remember your language settings (English, French, Spanish, etc.) and sidebar layout choices.</li>
              <li><strong>Performance Cookies:</strong> Help us understand platform latency and load times to optimize aeronautical chart rendering.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Managing Cookies</h2>
            <p>
              You can manage cookie preferences through your browser settings. However, disabling essential cookies will prevent the AviaGov platform from functioning correctly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Third-Party Cookies</h2>
            <p>
              AviaGov does not allow third-party marketing cookies on its enterprise instances. Any analytics cookies used are privacy-preserving and hosted on our own infrastructure.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
